import React from "react";
import { useTranslation } from "react-i18next";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";
import "./StatsStyle.css";

const Stats = () => {
  const { t, i18n } = useTranslation();
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.3 });

  const statsData = [
    {
      value: 6800,
      desc: t("stats.happyPatientsDesc"),
    },
    {
      value: 363,
      desc: t("stats.teethWhitenedDesc"),
    },
    {
      value: 218,
      desc: t("stats.dentalImplantsDesc"),
    },
    {
      value: 7,
      desc: t("stats.yearsExperienceDesc"),
    },
  ];

  return (
    <section
      ref={ref}
      className={`stats-section ${i18n.language === "ar" ? "rtl-layout" : ""}`}
    >
      <div className="stats-container">
        {statsData.map((stat, index) => (
          <div className="stat-item" key={index}>
            <h2>
              {inView ? <CountUp end={stat.value} duration={2.5} /> : "0"}
            </h2>
            <p className="stat-title">{stat.title}</p>
            <p className="stat-desc">{stat.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Stats;
